var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewArea",staticClass:"ly-tabbar",class:{ 'ly-tabbar-fix-bottom': _vm.fixBottom }},[_c('div',{ref:"list",staticClass:"ly-tab-list",style:(_vm.style)},[_vm._t("default"),(!_vm.fixBottom)?_c('div',{ref:"activeBar",staticClass:"ly-tab-active-bar",style:(_vm.activeBarStyle)}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }